
 <section class="container mt-5">
    <div class="row">
        <div class="col-md-12">
            <h6 id="h6">PLANNING YOUR TRIP TO</h6>
        </div>
        <div class="col-md-6">
            <button type="button" id="btn" class="btn btn-outline-secondary">Europe</button>
            &nbsp;&nbsp;
            <button type="button" id="btn" class="btn btn-outline-secondary">6 - 9 Days</button>
            &nbsp;&nbsp;
            <button type="button" id="btn" class="btn btn-outline-secondary">
                Adventure & Outdoor </button>
        </div>
        <div class="col-md-6">
            <i class="fa fa-close" id="times"></i>
        </div>
        <div class="col-md-3">
            <hr style="height:5px;border-width:0;color:gray;
            background-color: rgb(255, 201, 51);">
        </div>
        <div class="col-md-3">
            <hr style="height:5px;border-width:0;color:gray;
            background-color: rgb(255, 201, 51);">
        </div>
        <div class="col-md-2">
            <hr style="height:5px;border-width:0;color:gray;
            background-color: rgb(255, 201, 51);">
        </div>
        <div class="col-md-2">
            <hr style="height:5px;border-width:0;color:gray;
            background-color: rgba(44, 47, 66, 0.2);">
        </div>
        <div class="col-md-2">
            <hr style="height:5px;border-width:0;color:gray;
            background-color: rgba(44, 47, 66, 0.2);">
        </div>
        <div class="col-md-12">
            <h4 id="h4">What’s the duration of your holiday?</h4>
        </div>
        <div class="col-md-2">
            <div class="card" style="border-radius:10px;">
                <div class="card-body"><a href="/customizeinter">
                    <div style="text-align: center;margin-top: 50px;">
                        <img src="assets/images/9.jpg" class="rounded" style="width: 100px;" >
                    </div>
                    <div style="text-align: center;margin-top: 50px;margin-bottom: 60px;">
                        <h5>A bit of everything</h5>
                    </div></a>
                </div>
            </div>
        </div>
        <div class="col-md-2">
            <div class="card" style="border-radius:10px;">
                <div class="card-body"><a href="/#">
                    <div style="text-align: center;margin-top: 50px;">
                        <img src="assets/images/9.jpg" class="rounded" style="width: 100px;" >
                    </div>
                    <div style="text-align: center;margin-top: 50px;margin-bottom: 60px;">
                        <h5>Adventure & Outdoor</h5>
                    </div></a>
                </div>
            </div>
        </div>
        <div class="col-md-2">
            <div class="card" style="border-radius:10px;">
                <div class="card-body"><a href="/#">
                    <div style="text-align: center;margin-top: 50px;">
                        <img src="assets/images/9.jpg" class="rounded" style="width: 100px;" >
                    </div>
                    <div style="text-align: center;margin-top: 50px;margin-bottom: 60px;">
                        <h5>Adventure & Outdoor</h5>
                    </div></a>
                </div>
            </div>
        </div>
        <div class="col-md-2">
            <div class="card" style="border-radius:10px;">
                <div class="card-body"><a href="/#">
                    <div style="text-align: center;margin-top: 50px;">
                        <img src="assets/images/9.jpg" class="rounded" style="width: 100px;" >
                    </div>
                    <div style="text-align: center;margin-top: 50px;margin-bottom: 60px;">
                        <h5>Shopping & Leisure</h5>
                    </div></a>
                </div>
            </div>
        </div>
        <div class="col-md-2">
            <div class="card" style="border-radius:10px;">
                <div class="card-body"><a href="/#">
                    <div style="text-align: center;margin-top: 50px;">
                        <img src="assets/images/9.jpg" class="rounded" style="width: 100px;" >
                    </div>
                    <div style="text-align: center;margin-top: 50px;margin-bottom: 60px;">
                        <h5>Food & Nightlife</h5>
                    </div></a>
                </div>
            </div>
        </div>
    </div>
 </section>